import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11.655 19.458q.73 0 1.235-.51.505-.512.505-1.252c0-.74-.168-.91-.505-1.251a1.67 1.67 0 0 0-1.235-.511q-.732 0-1.236.51-.505.513-.505 1.252c0 .739.169.91.505 1.251q.505.51 1.236.511m.209-14.52q.87 0 1.514.564.643.564.643 1.41 0 .775-.47 1.374a9 9 0 0 1-1.061 1.128 9.3 9.3 0 0 0-1.41 1.55 3.18 3.18 0 0 0-.609 1.904q0 .494.366.828.365.335.853.335.522 0 .887-.353c.365-.353.4-.528.47-.88a2.85 2.85 0 0 1 .626-1.322q.487-.582 1.045-1.11a9 9 0 0 0 1.374-1.692 3.77 3.77 0 0 0 .575-2.044q0-1.798-1.445-2.943-1.444-1.145-3.358-1.145-1.323 0-2.524.563-1.2.564-1.827 1.727a1.29 1.29 0 0 0-.157.899q.087.476.47.722.487.282 1.01.177.522-.105.87-.6a2.56 2.56 0 0 1 .957-.81 2.7 2.7 0 0 1 1.2-.282Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }